import {Provider, inject, provideAppInitializer, EnvironmentProviders} from '@angular/core'
import { WINDOW } from '@features/storage/window'
import { USER_LANGUAGE } from '@features/i18n/providers'
import { COOKIE_CONSENT_LEVEL } from '@features/cookie-consents/contracts'

export const providers: (Provider|EnvironmentProviders)[] = [
  provideAppInitializer(() => {
        const initializerFn = ((window: Window|null, language: string) => () => window?.cookieconsent?.run({
      language,
      notice_banner_type: 'simple',
      page_load_consent_levels: [COOKIE_CONSENT_LEVEL.STRICTLY_NECESSARY],
      notice_banner_reject_button_hide: false,
    }))(inject(WINDOW), inject(USER_LANGUAGE))
        return initializerFn()
      }),
]
